import $store from '../store'
import config from '@/config'

// Example POST method implementation:
const fetchApi = async (url = '', method = '', data = {}, headers = {}) => {
  return new Promise(async (resolve, reject) => {
    if (url == '') {
      console.error('Cannot fetch without URL')
      return
    }
    method = method.toUpperCase()
    if (method == '') {
      method = 'GET'
    }
    if (method != 'GET' && method != 'POST' && method != 'PUT' && method != 'DELETE') {
      console.error('Invalid method, please use: GET, POST, PUT, DELETE ')
      return
    }
    try {
      let response
      if (method == 'GET') {
        response = await fetch(config.apiUrl + url, { method: method }).then(async resp => {
          let responseJson = await resp.json()
          responseJson.statusCode = resp.status
          return responseJson
        })
      }
      if (method == 'POST' || method == 'PUT' || method == 'DELETE') {
        data._csrf = $store.state.general.user.csrf
        let accept = {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
        Object.assign(headers, accept)
        response = await fetch(config.apiUrl + url, {
          headers: headers,
          method: method,
          body: JSON.stringify(data)
        }).then(async resp => {
          let responseJson = await resp.json()
          responseJson.statusCode = resp.status
          return responseJson
        })
      }
      resolve(response)
    } catch (err) {
      reject(err)
    }
  })
}

const fetchGraph = async (query, operationName) => {
  return new Promise(async (resolve, reject) => {
    async function goGetEm(query) {
      const headers = {
        Authorization: `Bearer ${$store.state.general.user.jwt.jwtToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
      const data = {
        query: query,
        operationName: operationName ? operationName : null
      }
      if (operationName !== 'refresh') {
        data._csrf = $store.state.general.user.csrf
      }
      const response = await fetch(config.graphUrl, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data)
      }).then(resp => {
        return resp.json()
      })
      return response
    }
    try {
      let response = await goGetEm(query)
      resolve(response)
    } catch (err) {
      console.log(err)
      reject(err)
    }
  })
}

const isEmpty = obj => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false
  }
  return true
}

const getRecords = async (query, queryName, options = {}) => {
  const defaultSettings = {
    array: [],
    where: '{}',
    sort: null,
    take: 200,
    skip: 0,
    limit: undefined
  }
  const type = queryName.substring(0, 3)
  const settings = { ...defaultSettings, ...options }
  let queryRequest = ''

  if (type === 'all') {
    if (settings.take > 200) {
      settings.take = 200
    }

    if (settings.limit) {
      if (settings.limit < settings.take) {
        settings.take = settings.limit
      } else {
        const remaining = settings.limit - settings.array.length
        if (remaining < settings.take) {
          settings.take = remaining
        }
      }
      if (settings.take === 0) {
        return settings.array
      }
    }

    queryRequest = `{
      ${queryName}(take: ${settings.take}, skip: ${settings.skip}, where: ${settings.where} ${
      settings.sort ? ',sort:' + settings.sort : ''
    }){
        results ${query}
        totalCount
      }
    }`
  } else {
    queryRequest = `{
      ${queryName}(where: ${settings.where})${query}
    }`
  }

  const result = await fetchGraph(queryRequest)
  if (result.data) {
    if (type === 'all') {
      settings.array.push(...result.data[queryName].results)
      if (result.data[queryName].totalCount > settings.array.length) {
        settings.skip = settings.skip + settings.take
        return await getRecords(query, queryName, settings)
      } else {
        let obj = {
          data: settings.array,
          totalCount: result.data[queryName].totalCount
        }
        return obj
      }
    } else {
      return result.data[queryName]
    }
  } else {
    console.error('\n', 'Errors:', '\n', result.errors, '\n', 'GQL:', '\n', queryRequest)
    return type === 'all' ? [] : {}
  }
}

export default { fetchApi, fetchGraph, isEmpty, getRecords }
